import RightSlider from 'component/hoc/rightSlider/RightSlider';
import React, { useState } from 'react';
import styles from './ViewCategories.module.scss';
import RoundedTabs from 'component/atom/Tabs/RoundedTabs';
import Topics from './Topics/Topics';
import Departments from './Departments/Departments';

const ViewCategories = ({
  isOpen,
  onClose,
  id,
  isRefetch,
  handleEdit,
  setIsAddCategory,
}) => {
  const [tab, setTab] = useState(0);

  const tabs = [
    {
      label: 'Topics',
    },
    {
      label: 'Departments',
    },
  ];

  return (
    <>
      <RightSlider
        action={{
          isOpen: isOpen,
          setIsOpen: onClose,
        }}
        title='All Categories'
        className={styles['slider']}
        titleClassName={styles['slider-header']}
      >
        <div className={styles.cont}>
          <RoundedTabs tabs={tabs} activeTab={tab} setActiveTab={setTab} />
          {0 === tab && <Topics />}
          {1 === tab && <Departments />}
        </div>
      </RightSlider>
    </>
  );
};

export default ViewCategories;
